// extracted by mini-css-extract-plugin
export default {"wrapper":"style_wrapper__br+vv","label":"style_label__-acqP","actions":"style_actions__k7ij+","actions_btn":"style_actions_btn__Cz6aa"};